import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { Observable } from 'rxjs';

import { NotificationTheme } from '@fcom/ui-components';
import { StepperStep } from '@fcom/ui-components/components/stepper/interfaces';

@Component({
  selector: 'fin-login-form-container',
  templateUrl: './login-form-container.component.html',
  styleUrls: ['./login-form-container.component.scss'],
})
export class LoginFormContainerComponent implements AfterViewInit {
  readonly NotificationTheme = NotificationTheme;
  @ViewChild('dialogTitle') dialogTitle: ElementRef;

  @Input()
  fullScreen = false;
  @Input()
  invertHeaderColors = false;
  @Input()
  icon: string;
  @Input()
  title: string;
  @Input()
  description: string;
  @Input()
  error: string;
  @Input()
  stepperSteps$: Observable<StepperStep[]>;
  @Input()
  stepperActiveStep$: Observable<number>;
  @Output()
  stepperClicked: EventEmitter<StepperStep> = new EventEmitter<StepperStep>();

  @Output()
  returnClicked: EventEmitter<Event> = new EventEmitter<Event>();
  @Output()
  closeClicked: EventEmitter<Event> = new EventEmitter<Event>();

  ngAfterViewInit(): void {
    this.dialogTitle.nativeElement.focus();
  }
}
